import { render, staticRenderFns } from "./MiniCartMobile.vue?vue&type=template&id=0ba3be84"
import script from "./MiniCartMobile.vue?vue&type=script&lang=js"
export * from "./MiniCartMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports